"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Close = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close16"));
var _Close2 = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close24"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _mixins = require("../../styles/mixins");
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBCloseButton = function HBCloseButton(_ref) {
  var onClick = _ref.onClick,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    size = _ref.size,
    testId = _ref.testId,
    testIdName = _ref.testIdName,
    distance = _ref.distance;
  return /*#__PURE__*/_react["default"].createElement(IconButton, {
    size: size,
    $distance: distance,
    onClick: onClick,
    label: "close",
    testId: testId,
    testIdName: testIdName,
    icon: SIZE_TO_ICON_MAP[size],
    buttonTheme: THEME_TO_BUTTON_THEME[theme]
  });
};
var _default = exports["default"] = HBCloseButton; // -------------------------- Styles -------------------------- //
var SIZE_TO_ICON_MAP = {
  xs: _Close["default"],
  sm: _Close2["default"],
  md: _Close2["default"],
  lg: _Close2["default"]
};
var THEME_TO_BUTTON_THEME = {
  dark: 'neutral-invisible',
  light: 'light-invisible'
};
var IconButton = (0, _styledComponents["default"])(_HBIconButton["default"]).withConfig({
  displayName: "HBCloseButton__IconButton",
  componentId: "sc-dkrdv9-0"
})(["", " position:absolute;", ""], _mixins.hideInPrint, function (_ref2) {
  var $distance = _ref2.$distance;
  return (0, _styledComponents.css)(["top:", "px;right:", "px;"], $distance, $distance);
});
//# sourceMappingURL=HBCloseButton.js.map